<div [formGroup]="form">

  <h3>{{ 'content.person.name' | translate }}</h3>
  <div class="row ms-0 me-0">
    <div class="col-md-3 col-sm-6">
      <label>{{ 'content.person.first-name' | translate }}: *
        <input class="form-control" type="text" autocomplete="on" formControlName="firstName" #firstNameInput>
      </label>
      <app-validation-errors [displayErrors]="displayErrors" [errors]="c.firstName.errors" [element]="firstNameInput"></app-validation-errors>
    </div>
    <div class="col-md-3 col-sm-6">
      <label>{{ 'content.person.middle-name' | translate }}:
        <input class="form-control" type="text" autocomplete="on" formControlName="middleName" #middleNameInput>
      </label>
      <app-validation-errors [displayErrors]="displayErrors" [errors]="c.middleName.errors" [element]="middleNameInput"></app-validation-errors>
    </div>
    <div class="col-md-3 col-sm-6">
      <label>{{ 'content.person.last-name' | translate }}: *
        <input class="form-control" type="text" autocomplete="on" formControlName="lastName" #lastNameInput>
      </label>
      <app-validation-errors [displayErrors]="displayErrors" [errors]="c.lastName.errors" [element]="lastNameInput"></app-validation-errors>
    </div>
  </div>

  <h3>{{ 'content.identification' | translate }}</h3>
  <div class="mb-2">{{ 'content.enter-one-sin-dob-account' | translate }}</div>
  <div class="row ms-0 me-0">
    <div class="form-group col-md-3">
      <label>{{ 'content.person.dob' | translate }}
        <input appHideOnBlur class="form-control" type="text" autocomplete="on" formControlName="dob" mask="0000-00-00" placeholder="yyyy-mm-dd" #dobInput>
      </label>
      <app-validation-errors [displayErrors]="displayErrors" [errors]="c.dob.errors" [element]="dobInput"></app-validation-errors>
    </div>
  </div>
  <div class="row ms-0 me-0">
    <div class="form-group col-md-3">
      <label>{{ 'content.social-insurance-number-short' | translate }}
        <input appHideOnBlur class="form-control" type="text" autocomplete="on" formControlName="sin" mask="000-000-000" placeholder="" #sinInput>
      </label>
      <app-validation-errors [displayErrors]="displayErrors" [errors]="c.sin.errors" [element]="sinInput"></app-validation-errors>
    </div>
  </div>
  <div class="row ms-0 me-0">
    <div class="form-group col-md-4 pe-2">
      <label>{{ 'content.card1' | translate }}
        <select class="form-select" formControlName="card" #cardInput>
          @for (cardType of cardTypes | keyvalue; track cardType) {
            <option value="{{ cardType.key }}">{{ cardType.value }}</option>
          }
        </select>
      </label>
      <app-validation-errors [displayErrors]="displayErrors" [errors]="c.card.errors" [element]="cardInput"></app-validation-errors>
    </div>
    <div class="form-group col-md-8">
      <label>{{ 'content.account-num' | translate }}
        <input appHideOnBlur class="form-control" type="text" autocomplete="on" formControlName="account" #accountInput>
      </label>
      <app-validation-errors [displayErrors]="displayErrors" [errors]="c.account.errors" [element]="accountInput"></app-validation-errors>
    </div>
  </div>

  <h3>{{ 'content.current-address' | translate }}</h3>
  <div class="row ms-0 me-0">
    <div class="form-group col-md-3 pe-2">
      <label>{{ 'content.address.street-num' | translate }}
        <input class="form-control" type="text" autocomplete="on" formControlName="streetNum" #streetNumInput>
      </label>
      <app-validation-errors [displayErrors]="displayErrors" [errors]="c.streetNum.errors" [element]="streetNumInput"></app-validation-errors>
    </div>
    <div class="form-group col-md-6 pe-2">
      <label>{{ 'content.address.street' | translate }} *
        <input class="form-control" type="text" autocomplete="on" formControlName="street" #streetInput>
      </label>
      <app-validation-errors [displayErrors]="displayErrors" [errors]="c.street.errors" [element]="streetInput"></app-validation-errors>
    </div>
    @if (c.apartmentNum) {
      <div class="form-group col-md-2">
        <label>{{ 'content.address.unit-apt' | translate }}
          <input class="form-control" type="text" autocomplete="on" formControlName="apartmentNum" #apartmentNumInput>
        </label>
        <app-validation-errors [displayErrors]="displayErrors" [errors]="c.apartmentNum.errors" [element]="apartmentNumInput"></app-validation-errors>
      </div>
    }
  </div>
  <div class="row ms-0 me-0">
    <div class="form-group col-md-4 pe-2">
      <label>{{ 'content.address.city' | translate }} *
        <input class="form-control" type="text" autocomplete="on" formControlName="city" #cityInput>
      </label>
      <app-validation-errors [displayErrors]="displayErrors" [errors]="c.city.errors" [element]="cityInput"></app-validation-errors>
    </div>
    <div class="form-group col-md-4">
      <label>{{ 'content.address.province' | translate }} *
        <select class="form-select" formControlName="province" #provinceInput>
          <option value=""></option>
          @for (province of provinceNames | keyvalue; track province) {
            <option value="{{ province.key }}">{{ province.value }}</option>
          }
        </select>
      </label>
      <app-validation-errors [displayErrors]="displayErrors" [errors]="c.province.errors" [element]="provinceInput"></app-validation-errors>
    </div>
  </div>
  <div class="row ms-0 me-0">
    <div class="form-group col-md-3">
      <label>{{ 'content.address.postal-code' | translate }} *
        <input class="form-control" type="text" autocomplete="on" formControlName="postalCode" mask="S0S-0S0" #postalCodeInput>
      </label>
      <app-validation-errors [displayErrors]="displayErrors" [errors]="c.postalCode.errors" [element]="postalCodeInput"></app-validation-errors>
    </div>
  </div>

  <div class="form-check ps-0">
    <label class="form-check-label">
      <input class="form-check-input" type="checkbox" formControlName="inclPrevAddress">
      {{ 'content.address.previous-address' | translate }}
    </label>
  </div>
  @if (c.inclPrevAddress.value) {
    <div class="mt-2">
      <h3>{{ 'content.address.previous-address' | translate }}</h3>
      <div class="row ms-0 me-0">
        <div class="form-group col-md-3 pe-2">
          <label>{{ 'content.address.street-num' | translate }}
            <input class="form-control" type="text" autocomplete="on" formControlName="prevStreetNum" #prevStreetNumInput>
          </label>
          <app-validation-errors [displayErrors]="displayErrors" [errors]="c.prevStreetNum.errors" [element]="prevStreetNumInput"></app-validation-errors>
        </div>
        <div class="form-group col-md-6 pe-2">
          <label>{{ 'content.address.street' | translate }} *
            <input class="form-control" type="text" autocomplete="on" formControlName="prevStreet" #prevStreetInput>
          </label>
          <app-validation-errors [displayErrors]="displayErrors" [errors]="c.prevStreet.errors" [element]="prevStreetInput"></app-validation-errors>
        </div>
        <div class="form-group col-md-2">
          <label>{{ 'content.address.unit-apt' | translate }}
            <input class="form-control" type="text" autocomplete="on" formControlName="prevApartmentNum" #prevApartmentNumInput>
          </label>
          <app-validation-errors [displayErrors]="displayErrors" [errors]="c.prevApartmentNum.errors" [element]="prevApartmentNumInput"></app-validation-errors>
        </div>
      </div>
      <div class="row ms-0 me-0">
        <div class="form-group col-md-4 pe-2">
          <label>{{ 'content.address.city' | translate }} *
            <input class="form-control" type="text" autocomplete="on" formControlName="prevCity" #prevCityInput>
          </label>
          <app-validation-errors [displayErrors]="displayErrors" [errors]="c.prevCity.errors" [element]="prevCityInput"></app-validation-errors>
        </div>
        <div class="form-group col-md-4">
          <label>{{ 'content.address.province' | translate }} *
            <select class="form-select" formControlName="prevProvince" #prevProvinceInput>
              <option value=""></option>
              @for (province of provinceNames | keyvalue; track province) {
                <option value="{{ province.key }}">{{ province.value }}</option>
              }
            </select>
          </label>
          <app-validation-errors [displayErrors]="displayErrors" [errors]="c.prevProvince.errors" [element]="prevProvinceInput"></app-validation-errors>
        </div>
      </div>
      <div class="row ms-0 me-0">
        <div class="form-group col-md-3">
          <label>{{ 'content.address.postal-code' | translate }} *
            <input class="form-control" type="text" autocomplete="on" formControlName="prevPostalCode" mask="S0S-0S0" #prevPostalCodeInput>
          </label>
          <app-validation-errors [displayErrors]="displayErrors" [errors]="c.prevPostalCode.errors" [element]="prevPostalCodeInput"></app-validation-errors>
        </div>
      </div>
    </div>
  }

  <h3>{{ 'content.phone.phone' | translate }}</h3>
  <div class="row ms-0 me-0">
    <div class="form-group col-md-4">
      <label>{{ 'content.phone.phone' | translate }}
        <input class="form-control" type="tel" autocomplete="on" formControlName="phone" mask="(000) 000-0000" #phoneInput>
        <app-validation-errors [displayErrors]="displayErrors" [errors]="c.phone.errors" [element]="phoneInput"></app-validation-errors>
      </label>
    </div>
  </div>

  <h3>{{ 'content.employment' | translate }}</h3>
  <div class="row ms-0 me-0">
    <div class="form-group col-md-4 pe-2">
      <label>{{ 'content.person.occupation' | translate }}
        <input class="form-control" type="text" autocomplete="on" formControlName="job" #jobInput>
      </label>
      <app-validation-errors [displayErrors]="displayErrors" [errors]="c.job.errors" [element]="jobInput"></app-validation-errors>
    </div>
    <div class="form-group col-md-4">
      <label>{{ 'content.employer' | translate }}
        <input class="form-control" type="text" autocomplete="on" formControlName="employer" #employerInput>
      </label>
      <app-validation-errors [displayErrors]="displayErrors" [errors]="c.employer.errors" [element]="employerInput"></app-validation-errors>
    </div>
  </div>

</div>
